import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AppError } from '@app/core/errors/app-error.model';

@Component({
    selector: 'app-page-error-state',
    templateUrl: './page-error-state.component.html',
    styleUrls: ['./page-error-state.component.scss'],
    imports: [CommonModule, TranslateModule]
})
export class PageErrorStateComponent {
    @Input({ required: true }) error!: AppError;
    @Input() retryLabel = 'Reintentar';
    @Output() retry = new EventEmitter<void>();
}
